import React  from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import placeholderImg from 'assets/images/img-placeholder.png';
import SimpleDialog from 'components/SimpleDialog';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import FollowShowActionIcon from 'components/ActionIcons/FollowShow';
import { autoOptimizeImage } from 'utils/functions';
import { dataLayerPush } from 'utils/dataLayer';
import showShape from 'shapes/showShape';

const StyledDialogContentText = styled(DialogContentText)`
  margin-bottom: 0.75rem;
`;

const StyledDialogContent = styled(DialogContent)`
  && {
    padding: 0.5rem 1.25rem;
  }
`;

MobileModal.propTypes = {
  history: PropTypes.object,
  shortDescription: PropTypes.string,
  showDetailsModal: PropTypes.bool,
  setShowDetailsModal: PropTypes.func,
  showUrl: PropTypes.string,
  show: showShape,
  teaser: PropTypes.string,
  title: PropTypes.string,
  user: PropTypes.object,
};

function MobileModal({
  history,
  shortDescription,
  showDetailsModal,
  setShowDetailsModal,
  showUrl,
  show,
  teaser,
  title,
  user
}) {
  const handleAction = (actionName, event) => {
    const action = mobileActionItems.find(v => v.value === actionName);

    if (action?.callback) {
      action?.callback(event);
    }
    setShowDetailsModal(false);
    dataLayerPush('Mobile show card modal closed');
  }

  const mobileActionItems = [
    {
      value: 0,
      label: <strong>Explore</strong>,
      icon: <ArrowForwardIcon style={{ marginLeft: '-0.25rem' }} />, // Negative margin-left to left-align play arrow icon with others.
      callback: () => {
        history.push(showUrl);
        dataLayerPush(`'Explore' show link clicked`);
      }
    },
    {
      value: 1,
      icon: <FollowShowActionIcon show={show} postLabel={true} fontSize='medium'  />,
      hide: !user
    }
  ];

  return (
    <SimpleDialog
      onClose={handleAction}
      open={showDetailsModal}
      options={mobileActionItems}
      headerImage={autoOptimizeImage(show.image?.url || placeholderImg)}
    >
      <StyledDialogContent>
        <StyledDialogContentText color='textPrimary'>
          <h3 style={{marginBottom: '0.5rem'}}>{title}</h3>
          {
            teaser ? <>{teaser}</> :
            shortDescription ? <div dangerouslySetInnerHTML={{ __html: shortDescription }} /> :
            <>{''}</>
          }
        </StyledDialogContentText>
      </StyledDialogContent>
    </SimpleDialog>
  );
}

export default MobileModal;
